function tryParseDate(value) {
    if (!value) return null;

    const strValue = String(value).trim();

    // Formato ISO: YYYY-MM-DD ou YYYY-MM-DDTHH:mm:ss...
    const isoMatch = strValue.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (isoMatch) {
        const [, year, month, day] = isoMatch;
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }

    // Formato brasileiro: DD/MM/YYYY ou DD-MM-YYYY
    const brDateMatch = strValue.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
    if (brDateMatch) {
        const [, day, month, year] = brDateMatch;
        return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }

    return null;
}

function normalizeDateValue(value) {
    const date = tryParseDate(value);
    if (!date) return null;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

function normalizeValue(value) {
    if (value === null || value === undefined) return value;

    const strValue = String(value).toLowerCase().trim();

    if (strValue === "1" || strValue === "true" || strValue === "sim" || strValue === "yes") {
        return "sim";
    }

    if (strValue === "0" || strValue === "false" || strValue === "não" || strValue === "nao" || strValue === "no") {
        return "não";
    }

    return strValue;
}

function evaluateCondition(condition, answers) {
    const { question_id, condition_value, comparison_operator } = condition;
    const answerValue = answers[question_id];

    const hasAnswer = answerValue !== undefined && answerValue !== null && answerValue !== "";

    switch (comparison_operator) {
        case "QUESTION_ANSWERED":
            return hasAnswer;

        case "EQUAL":
            {
              if (!hasAnswer) return false;

              const normalizedDateAnswer = normalizeDateValue(answerValue);
              const normalizedDateCondition = normalizeDateValue(condition_value);
              if (normalizedDateAnswer && normalizedDateCondition) {
                  return normalizedDateAnswer === normalizedDateCondition;
              }

              return normalizeValue(answerValue) === normalizeValue(condition_value);
            }

        case "NOT_EQUAL":
            {
              if (!hasAnswer) return true;

              const normalizedDateAnswerNE = normalizeDateValue(answerValue);
              const normalizedDateConditionNE = normalizeDateValue(condition_value);
              if (normalizedDateAnswerNE && normalizedDateConditionNE) {
                  return normalizedDateAnswerNE !== normalizedDateConditionNE;
              }

              return normalizeValue(answerValue) !== normalizeValue(condition_value);
            }

        case "GREATER_THAN":
            {
              if (!hasAnswer) return false;

              const dateAnswerGT = tryParseDate(answerValue);
              const dateConditionGT = tryParseDate(condition_value);
              if (dateAnswerGT && dateConditionGT) {
                  return dateAnswerGT.getTime() > dateConditionGT.getTime();
              }

              const numAnswerGT = parseFloat(answerValue);
              const numConditionGT = parseFloat(condition_value);
              if (isNaN(numAnswerGT) || isNaN(numConditionGT)) return false;
              return numAnswerGT > numConditionGT;
            }

        case "LESS_THAN":
          {
            if (!hasAnswer) return false;

            const dateAnswerLT = tryParseDate(answerValue);
            const dateConditionLT = tryParseDate(condition_value);
            if (dateAnswerLT && dateConditionLT) {
                return dateAnswerLT.getTime() < dateConditionLT.getTime();
            }

            const numAnswerLT = parseFloat(answerValue);
            const numConditionLT = parseFloat(condition_value);
            if (isNaN(numAnswerLT) || isNaN(numConditionLT)) return false;
            return numAnswerLT < numConditionLT;
          }

        case "INCLUDES":
            if (!hasAnswer) return false;
            if (Array.isArray(answerValue)) {
                return answerValue.some(v =>
                    String(v).toLowerCase().includes(String(condition_value).toLowerCase())
                );
            }
            return String(answerValue).toLowerCase().includes(String(condition_value).toLowerCase());

        default:
            console.warn(`Unknown comparison operator: ${comparison_operator}`);
            return false;
    }
}

function evaluateConditionGroup(conditionGroup, answers) {
    if (!conditionGroup) return true;

    const { conditional_operator, childrens = [], conditions = [] } = conditionGroup;

    const conditionResults = conditions.map(condition => evaluateCondition(condition, answers));

    const childrenResults = childrens.map(child => evaluateConditionGroup(child, answers));

    const allResults = [...conditionResults, ...childrenResults];

    if (allResults.length === 0) return true;

    if (conditional_operator === "AND") {
        return allResults.every(result => result === true);
    } else if (conditional_operator === "OR") {
        return allResults.some(result => result === true);
    }

    return true;
}

export function isQuestionVisible(question, answers) {
    if (!question.visibility_condition) {
        return true;
    }

    let conditionGroup = question.visibility_condition;
    if (typeof conditionGroup === "string") {
        try {
            conditionGroup = JSON.parse(conditionGroup);
        } catch (e) {
            console.error("Failed to parse visibility_condition:", e);
            return true;
        }
    }

    return evaluateConditionGroup(conditionGroup, answers);
}

export function filterVisibleQuestions(questions, answers) {
    if (!questions || !Array.isArray(questions)) return [];
    return questions.filter(question => isQuestionVisible(question, answers));
}

export default {
    isQuestionVisible,
    filterVisibleQuestions,
    evaluateCondition,
    evaluateConditionGroup
};
